module.exports = __webpack_public_path__ + "img/santa-hat.e70b576e.png";